import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BlenderIcon(props: IconProps) {
    return <Icon {...props} iconKey={"blender"}/>
}
